export class UploadKyc {
  mobileNo: string;
  token: string;
  customerName: string;
  errMsg: string;
  kycType: string;
  appName: string;
  redirectURL: string;
  uploadKycDetails: UploadKycDetails;
}

export class UploadKycDetails {
  message: string;
  status: boolean;
  extracted: boolean;
  decriptedMobileNumber: string;
  photoString: string;
  content: string;
  signString: string;
  aadharType: string;
  fileData: any;
  fileName: string;
  shareCode: string;
  aadhaarDetail: AadhaarDetails;
}

export class AadhaarDetails {
  photoValue: string;
  signatureValue: string;
  mobileNumber: string;
  dateOfBirth: string;
  gender: string;
  name: string;
  careof: string;
  country: string;
  dist: string;
  house: string;
  pc: string;
  po: string;
  state: string;
  street: string;
  subdist: string;
  vtc: string;
  digestValue: string;
  xmlMobileNumber: string;
  address: string;
  digitalSignature: boolean;
}
